var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationsSometimes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 31.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36,14.62c0,8.08-8,14.63-18,14.63a21.72,21.72,0,0,1-6.53-1A17,17,0,0,1,1.69,31.5,1.69,1.69,0,0,1,.46,28.65a17.53,17.53,0,0,0,3.26-5.14A13,13,0,0,1,0,14.62C0,6.55,8.06,0,18,0S36,6.55,36,14.62Zm-2.25,0C33.75,7.8,26.69,2.25,18,2.25S2.25,7.8,2.25,14.62A10.64,10.64,0,0,0,5.36,22l1,1-.5,1.31A19.26,19.26,0,0,1,3,29.19a15.11,15.11,0,0,0,7.21-2.78l.92-.65,1.07.34A19.3,19.3,0,0,0,18,27C26.69,27,33.75,21.45,33.75,14.62Zm-23.06,0A1.69,1.69,0,1,1,9,12.94,1.68,1.68,0,0,1,10.69,14.62Zm9,0A1.69,1.69,0,1,1,18,12.94,1.68,1.68,0,0,1,19.69,14.62Zm9,0A1.69,1.69,0,1,1,27,12.94,1.68,1.68,0,0,1,28.69,14.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationsSometimes);
export default __webpack_public_path__ + "static/media/conversations-sometimes.6ade3c76f0036a57a36d5cde31efdffa.svg";
export { ForwardRef as ReactComponent };